module.exports = __webpack_public_path__ + "static/img/4.22c2727.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/zh/4.png
// module id = tSiW
// module chunks = 0